// Figma: "Logo wrap" (e.g. node 18050:156) — exported as one lockup asset (icon + wordmark).
import React from 'react';
import {Box} from '@mui/material';
import logo from '../../../assets/auth/logo.svg';

const AuthLogo = () => <Box component="img" src={logo} alt="Stake" sx={{height: '32px', width: '153px', display: 'block'}} />;

export default AuthLogo;
